import React, { useEffect, useState } from 'react';
import { Col, Row, Card, Accordion, Button } from 'react-bootstrap';
import prof from '../../../../assets/images/prof.svg';
import downloadIcon from '../../../../assets/images/download.svg';
import './JobApplicants.css';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { ReqGet, ReqPost } from '../../../../config/Requests';
import { toast } from 'react-toastify';

function ShortlistApplicants(props) {
	const { id } = useParams();
	const [filledJobModel, setFilledJobModel] = useState(false);
	const [jobId, setJobId] = useState('');
	const [memberId, setSelectMemberId] = useState('');
	const navigate = useNavigate();
	const [memberSelected, setMemberSelected] = useState([]);
	const [memberSelection, setMemberSelection] = useState([]);
	const [shortlistApplicants, setShortlistApplicants] = useState([]);

	const filledJob = () => {
		if (memberSelected?.length < 1) {
			return toast.error('please select atleast 1 member to fill job');
		}

		ReqPost(`filled/job/${id}`, { selected_applicants: memberSelected })
			.then(res => {
				if (res.status === 200) {
					ReqGet('jobs')
						.then(res => {
							toast.success('Job has been filled Successfully');

							setFilledJobModel(false);
							navigate('/');
						})
						.catch(err => {
							console.log(err.response);
						});
					ReqGet('archive-jobs')
						.then(res => {})
						.catch(err => {
							console.log(err.response);
						});
				}
			})
			.catch(err => {
				console.log(err.response);
			});
	};
	const filledJobFunc = member => {
		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				if (data) {
					setMemberSelection(
						data?.data?.members_applied_and_not_reject_or_decline
					);
				}
			})
			.catch(err => console.log(err));
		setFilledJobModel(true);

		setJobId(id);
		setSelectMemberId(member);
	};
	const memberSelectionFun = e => {
		const { value, checked } = e.target;
		if (!checked)
			return setMemberSelected(memberSelected.filter(d1 => d1 != value));
		setMemberSelected([...memberSelected, e.target.value]);
	};
	const viewProfileHandler = item => {
		navigate(`/job/${id}/applicants/view-profile`, {
			params: { profile: item },
		});
	};
	useEffect(() => {
		ReqGet(`shortlist/job/${id}`)
			.then(res => {
				setShortlistApplicants(res.data);
			})
			.catch(err => {
				console.log(err.response);
			});
	}, []);
	const declineShortlistHandler = (memberId, jobId) => {
		ReqPost(`remove-from-shortlist/job/${jobId}`, { members: memberId })
			.then(res => {
				console.log(res.data);
				ReqGet(`shortlist/job/${id}`)
					.then(res => {
						setShortlistApplicants(res.data);
						props.declined(memberId, jobId);
						console.log(res.data);
					})
					.catch(err => {
						console.log(err.response);
					});
			})
			.catch(err => {
				console.log(err.message);
			});
	};
	return (
		<div style={{ minHeight: '400px', height: 'auto' }}>
			{/* Filled Job Model */}
			{/* <Modal show={filledJobModel} onHide={() => setFilledJobModel(false)} centered>
        <Modal.Header >
        <Modal.Title className="modal-title w-100" style={{ fontSize: '20px', textAlign: 'center' }}>Please Select Member to Filled Job</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '20px', textAlign: 'center' }}>
          <em>
          {memberSelection?.map((data, index) => (
              <div style={{float:'left'}}>
                <input onChange={(e) => memberSelectionFun(e)} type="checkbox" id={index} name="members" value={data.id} />
                <label for="vehicle1">&nbsp;&nbsp; {data.fullname}</label><br />
              </div>
            ))}
          </em></Modal.Body>
        <Modal.Footer>
          <div style={{ margin: 'auto' }}>
            <Button variant="primary" onClick={filledJob}>
              Filled Job
            </Button> &nbsp;&nbsp;
            <Button variant="danger" onClick={() => setFilledJobModel(false)}>
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal> */}
			{/*  */}
			{/* new Filled JOb modal */}
			<Modal
				size='sm'
				show={filledJobModel}
				onHide={() => setFilledJobModel(false)}
			>
				<Modal.Header className='no-border text-center'>
					<Modal.Title className='modal-title w-100 font-weight-bolder'>
						Fill Job
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className='text-center'>Please select applicant for this Job</p>
					<p className='text-start'>
						{memberSelection?.map((data, index) => (
							<div key={index}>
								<input
									onChange={e => memberSelectionFun(e)}
									type='checkbox'
									id={index}
									name='members'
									value={data.id}
								/>
								<label htmlFor='vehicle1'>&nbsp;&nbsp; {data.fullname}</label>
								<br />
							</div>
						))}
					</p>
				</Modal.Body>
				<Modal.Footer className='no-border'>
					<Button
						className='w-100  fw-bold btn-logout'
						variant='primary'
						onClick={filledJob}
					>
						FILL JOB
					</Button>
					<Button
						className='w-100 fw-bold btn-logout'
						variant='danger'
						onClick={() => setFilledJobModel(false)}
					>
						CANCEL
					</Button>
				</Modal.Footer>
			</Modal>
			<div className='Filled-Job'>
				<h6 className='title mt-4 mb-4' style={{ float: 'left' }}>
					Shortlisted Applicants
				</h6>
				<Button
					variant='success'
					style={{
						'font-weight': 300,
						fontSize: '13px',
						padding: '05px',
						height: '30px',
						'margin-top': '3%',
						width: '18%',
						float: 'right',
					}}
					onClick={() => filledJobFunc()}
				>
					Fill Job
				</Button>
			</div>
			<Row className='cards-container'>
				{shortlistApplicants?.map((item, i) => {
					return (
						<Accordion key={i}>
							<Card className='accordion-card'>
								<Accordion.Toggle
									as={Button}
									variant='link'
									eventKey='0'
									style={{ backgroundColor: 'lightgrey' }}
								>
									<div style={{ display: 'flex' }}>
										<h6 style={{ marginRight: '5px' }}>
											ID: {item.id} {item.fullname}
										</h6>
									</div>
								</Accordion.Toggle>
								<Accordion.Collapse eventKey='0'>
									<Card className='applicant-card'>
										<Card.Body>
											<Row className='row'>
												<img
													className='profile-img'
													src={item.profile_image ? item.profile_image : prof}
													alt='profile'
												/>
												<Col>
													<h6 className='name'>{item.fullname}</h6>
													<p className='designation'>ID: {item.id}</p>
													<p className='email'>{item.email}</p>
													<p className='phone-number'>{item.phone}</p>
												</Col>

												<button
													className='btn-download-resume p-2'
													onClick={() => viewProfileHandler(item)}
												>
													View {item.fullname}'s Profile
												</button>
												<button
													className='btn-decline'
													onClick={() =>
														declineShortlistHandler(item.id, item.pivot.job_id)
													}
												>
													Decline
												</button>
											</Row>
										</Card.Body>
									</Card>
								</Accordion.Collapse>
							</Card>
						</Accordion>
					);
				})}
			</Row>
		</div>
	);
}

export default ShortlistApplicants;
